const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e27523ab-653a-4a66-a9f8-186ce411bc1b",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M8.16,9.21H2.31A1.54,1.54,0,0,1,.77,7.67V6a.7.7,0,0,1,1.4,0V7.67a.14.14,0,0,0,.14.14H8.16a.14.14,0,0,0,.14-.14V6A.7.7,0,0,1,9.7,6V7.67A1.54,1.54,0,0,1,8.16,9.21ZM5.73,6.5,7.82,4.41a.7.7,0,0,0-1-1L5.24,5,3.64,3.42a.69.69,0,0,0-1,0,.71.71,0,0,0,0,1L4.74,6.5a.74.74,0,0,0,.5.2A.71.71,0,0,0,5.73,6.5ZM5.94,6V1a.7.7,0,1,0-1.4,0V6a.7.7,0,0,0,1.4,0Z",
    style: {
      fill: "#575757"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.29549ce7c2cbd6e37fad54fd7cf0e8e3.svg";
export { ForwardRef as ReactComponent };